"use strict";
jQuery(document).ready(function () {
    console.log('Inside ');
    jQuery('[id^="showModalButton-"]').each(function () {
        const buttonId = jQuery(this).attr('id');
        console.log('buttonId ');
        const uniqueId = buttonId.split('-')[1];
        console.log('uniqueId ');
        const modalId = '#button_cta_form_modal-' + uniqueId;
        console.log('modalId ');
        jQuery(this).on('click', function () {
            jQuery(modalId).modal('show');
            console.log('"Modal is open ');
        });
        jQuery(modalId).on('hidden.bs.modal', function () {
            console.log('Modal is closed');
        });
    });
});
